import { render } from "./IconWizardMark.vue?vue&type=template&id=5c927a58"
import script from "./IconWizardMark.vue?vue&type=script&lang=js"
export * from "./IconWizardMark.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/branding/IconWizardMark.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c927a58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c927a58', __exports__)) {
    api.reload('5c927a58', __exports__)
  }
  
  module.hot.accept("./IconWizardMark.vue?vue&type=template&id=5c927a58", () => {
    api.rerender('5c927a58', render)
  })

}


export default __exports__